import numberOrZero from "./numberOrZero";

export const isEdge = () => navigator.appVersion.includes('Edge');

export const dispatchCartUpdateWindowEvent = (cartCount) => {
    const count = numberOrZero(cartCount);
    const event = new CustomEvent('cartUpdate', { detail: String(count)});
    window.dispatchEvent(event);
};
